import { makeStyles } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useRef, useState } from 'react';
import { Controller } from 'react-hook-form';
import { theme } from 'theme';
import CustomTextFieldComponent from './CustomTextFieldComponent';

const useStyles = makeStyles({
  input: {
    '& .MuiInputBase-root.MuiOutlinedInput-root.MuiAutocomplete-inputRoot': {
      height: '40px',
      paddingTop: 0,
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.colors.primary.red,
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: theme.colors.primary.red,
    },
    '& .MuiChip-root': {
      height: '25px !important',
    },
  },
});

const RHFAutocomplete = ({
  options,
  label,
  name,
  control,
  rules,
  freeSolo,
  multiple = false,
  disabled = false,
  defaultValue,
}) => {
  const subRef = useRef(null);
  const classes = useStyles();

  const [forceDisabled, setForceDisabled] = useState(false);

  useEffect(() => {
    if (options) {
      if (options?.length) setForceDisabled(false);
      else {
        subRef?.current
          ?.querySelector('.MuiAutocomplete-clearIndicator')
          ?.click();
        setForceDisabled(true);
      }
    }
  }, [options]);

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue || []}
      render={(props) => {
        return (
          <Autocomplete
            {...props}
            id={`${name}_id`}
            ref={subRef}
            multiple={multiple}
            options={options || []}
            getOptionLabel={(option) => option.label}
            className={classes.input}
            disabled={forceDisabled || disabled}
            onChange={(_event, value) => props.onChange(value)}
            renderInput={(params) => {
              return (
                <CustomTextFieldComponent
                  {...(freeSolo && {
                    onChange: props.onChange,
                  })}
                  {...params}
                  label={label}
                  variant="outlined"
                  value={props.value}
                />
              );
            }}
          />
        );
      }}
    />
  );
};

export default RHFAutocomplete;
